<template>
  <hr class="m-2 w-full border-t-1 border-outline/16" />
</template>

<script>
export default {
  name: 'Divider',
}
</script>
